import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useState, useCallback } from 'react';
import GroupGallectionSelector from '../../../GroupGallectionSelector';
import MediaSelector from '../../MediaSelector/MediaSelector';
const MediaSelectorWithGroupGallection = (_param)=>{
    var { group, gallectionType = 'gallery', onSelect } = _param, props = _object_without_properties(_param, [
        "group",
        "gallectionType",
        "onSelect"
    ]);
    const [selectedGallection, setSelectedGallection] = useState(undefined);
    const onGroupGallectionSelect = useCallback((gallection)=>setSelectedGallection(gallection), []);
    const onSelectCallback = useCallback(([deviation])=>{
        var _selectedGallection;
        return onSelect(deviation, group, gallectionType, (_selectedGallection = selectedGallection) === null || _selectedGallection === void 0 ? void 0 : _selectedGallection.folderId);
    }, [
        onSelect,
        group,
        gallectionType,
        selectedGallection
    ]);
    return /*#__PURE__*/ React.createElement(MediaSelector, _object_spread_props(_object_spread({}, props), {
        subheading: /*#__PURE__*/ React.createElement(GroupGallectionSelector, {
            group: group,
            gallectionType: gallectionType,
            selected: selectedGallection,
            onSelect: onGroupGallectionSelect
        }),
        onSelect: onSelectCallback
    }));
};
MediaSelectorWithGroupGallection.displayName = 'MediaSelectorWithGroupGallection';
export default MediaSelectorWithGroupGallection;
